import underscore from 'underscore';

const _ = underscore;

// Only boolean result
const check = {
    validPattern(type, inputString) {
        var rgxPattern = ""
        switch (type) {
            case 'email'             : rgxPattern = /^[_a-z0-9-]+([_+.a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*(\.[a-z]{2,})$/i; break;
            case 'fullname'          : rgxPattern = /^[\u2018-\u201D!-~a-z0-9 \u4e00-\u9eff]*$/i; break;
            case 'number'            : rgxPattern = /^[0-9]+$/; break;
            case 'occupation'        : rgxPattern = /^[\u2018-\u201D!-~a-z0-9 ]*$/i; break;
            case 'shMobileNo'        : rgxPattern = /^(8|9){1}[0-9]{7}$/; break;
            case 'mobilephone189'    : rgxPattern = /^\s*(8|9){1}[0-9]{7}$/; break;
            case 'alphanumeric'      : rgxPattern = /^[A-Za-z0-9]+$/; break;
            case 'alphaNumericSpaces': rgxPattern = /^[A-Za-z0-9 ]+$/; break;
            case 'password'          : rgxPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-"'()+,./:;<=>[\]\\^_`{}|~]).{8,}$/;break; /* alphanumberic, min: 8 chars, 1 upper, 1 lower, 1 special char */
        }

        if(type === "documentid189"){
            return inputString.trim() == "" ? false : this.checkIdDocument(inputString)
        }else if(type === "nric"){
            return inputString.trim() == "" || inputString.trim().length != 9  ? false : this.isNricValid(inputString)
        }else if(type === "fin"){
            return inputString.trim() == "" || inputString.trim().length != 9? false : this.isFinValid(inputString)
        }else{
            return rgxPattern.test(inputString);
        }

    },
    isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    },
    checkIdDocument(val) {
        const idValue = val;
        if(idValue.indexOf(" ") > -1 /*|| !this.isFinValid(val)*/  || val.length!=9 ){
            return false;
        }

        return true;
    },
    isNricValid(theNric) {
        var multiples = [2,7,6,5,4,3,2];
        if (!theNric || theNric == '')
        {
            return false;
        }

        if (theNric.length != 9)
        {
            return false;
        }

        var theNricArray = theNric.split("");

        var total = 0
            , numericNric;
        var first = theNricArray[0]
            , last = theNricArray[theNric.length - 1];

        first = first.toUpperCase();
        last = last.toUpperCase();

        if (first != 'S' && first != 'T')
        {
            return false;
        }

        numericNric = theNric.substr(1, theNric.length - 2);

        if (isNaN(numericNric)) {
            return false
        }
        var numericNricArray = numericNric.split("");

        var counterNumericNric = 0;
        while (counterNumericNric < 7)
        {
            total += numericNricArray[counterNumericNric] * multiples[counterNumericNric];

            counterNumericNric++;
        }

        if(first == 'T'){
            total += 4;
        }

        var outputs = [ 'J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A' ];

        return last == outputs[total % 11];

    },
    isFinValid(fin){
        var multiples = [2,7,6,5,4,3,2]
        if (!fin || fin == '')
        {
            return false;
        }

        if (fin.length != 9)
        {
            return false;
        }

        var finArray = fin.split("");

        var total = 0
            //, count = 0
            , numericNric;
        var first = finArray[0]
            , last = finArray[fin.length - 1];

        first = first.toUpperCase();
        last = last.toUpperCase();

        if (first != 'F' && first != 'G' && first != 'M')
        {
            return false;
        }

        numericNric = fin.substr(1, fin.length - 2);

        if (isNaN(numericNric)) {
            return false;
        }

        var numericNricArray = numericNric.split("");

        var counterNumericNric = 0;
        while (counterNumericNric < 7)
        {
            total += numericNricArray[counterNumericNric] * multiples[counterNumericNric];

            counterNumericNric++;
        }

        if(first == 'G' || first == 'M'){
            total += 4;
        }

        var outputs = [];

        if(first == 'M'){
            outputs = [ 'K', 'X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'J', 'L' ];
        }else{
            outputs = [ 'X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K' ];
        }
        return last == outputs[total % 11];
    },
    underage(customerDOB){
        var isUnder   = false;
        var dob       = new Date();

        var today     = new Date();
        var dd        = today.getDate();
        var mm        = today.getMonth() + 1;
        var yyyy      = today.getFullYear();

        var splitDate = customerDOB.split("-");

        if ( dd < 10 ) {
            dd ='0'+dd;
        }
        if ( mm < 10 ) {
            mm ='0'+mm;
        }
        today        = yyyy + '-' + mm + '-' + dd;
        splitDate[0] = parseInt(splitDate[0])+17;
        dob          = splitDate[0] + '-' + splitDate[1] + '-' + splitDate[2];

        if ( dob > today ) {
            isUnder=true;
        }
        return isUnder;
    },
    isProfanity(input) {
        // const profanityWords = process.env.VUE_APP_BAD_WORDS.split('').reverse().join('');
        const profList = "puc 1 slrig 2,c1g2,e5r4,t1h5,tih5,$$a,eloh$$a,$$@,s_s_a,m2a,45a,55a,eloh55a,suloea,eloha,tekcop toh amabala,enilepip naksala,lana,relapmi lana,egakael lana,einnalana,eborplana,xeslana,sugnilina,suna,tihsepa,e5ra,aloera,eloera,naira,esrra,esra,elohesra,nayra,ssa,kcuf ssa,eloh ssa,tluassa,gabssa,reggabssa,tidnabssa,gnabssa,degnabssa,regnabssa,sgnabssa,etibssa,retsalbssa,nwolcssa,kcocssa,rekcarcssa,sessa,ecafssa,secafssa,kcufssa,rekcufssa,rekcuf-ssa,akkufssa,nilbogssa,el0hssa,tahssa,tah-ssa,daehssa,e1ohssa,elohssa,selohssa,reppohssa,erohssa,rebbaj-ssa,rekcajssa,yekcojssa,ssikssa,ressikssa,nwolkssa,kcilssa,rekcilssa,revolssa,namssa,retsamssa,yeknomssa,sucumssa,hcnumssa,rehcnumssa,regginssa,rekcapssa,etaripssa,etarip-ssa,seippupssa,regnarssa,tihsssa,elohsssa,rekcusssa,dawssa,elohwssa,erohwssa,epiwssa,sepiwssa,citore otua,citoreotua,dnuowxa,lezaza,zza,hct!b,sb00b,hc71b,hct1b,ebab,dnalebab,sebab,rettab ybab,eciuj ybab,kcufdab,gag llab,yvarg llab,gnikcik llab,gnikcil llab,kcas llab,gnikcus llab,gabllab,rekcilllab,sllab,kcasllab,topmab,gnab,xob )s'eno( gnab,sorbgnab,regnab,gnignab,kcaberab,lagel ylerab,dekanerab,frab,ecafrab,ecaffrab,dratsab,odratsab,sdratsab,odanitsab,yob yttab,ydwab,sagnozab,smoozab,wbb,msdb,renaeb,srenaeb,malcdedraeb,laitsaeb,ytilaitsaeb,hctaeb,retaeb,taemruoytaeb,revaeb,revaelc revaeb,spil revaeb,niatruc feeb,sniatruc feeb,reeb,hctoyeeb,dnelleb,redneb,hctoeb,laitseb,ytilaitseb,hc+ib,hctaib,suoirucib,kcalb gib,stsaerb gib,srekconk gib,stit gib,dratsabgib,ttubgib,reggib,stitgib,obmib,sobmib,tnib,kcoldrib,lauxesib,lauxes-ib,hctib,tit hctib,ssahctib,dehctib,rehctib,srehctib,sehctib,zehctib,nihctib,gnihctib,stithctib,yhctib,kcoc kcalb,noitca ednolb,noitca ednolb no ednolb,taalcdoolb,ydoolb,lleh ydoolb,wolb,boj wolb,em wolb,dum wolb,daol ruoy wolb,bojwolb,sbojwolb,elffaw eulb,nikpmulb,gnaob,dob,ylidob,nagob,knuhob,kniob,saloiob,kcillob,kcollob,skcollob,kollob,xollob,dmob,egadnob,enob,denob,renob,srenob,gnob,boob,seiboob,sboob,yboob,regoob,eikoob,gnoob,agnoob,sbooob,sboooob,sbooooob,sbooooooob,eetoob,eitoob,ytoob,llac ytoob,ezoob,rezoob,yzoob,mosob,ymosob,lewob,slewob,arb,ereissarb,tsaerb,bojtsaerb,revoltsaerb,namtsaerb,stsaerb,redeerb,rekcufrehtorb,srewohs nworb,noitca ettenurb,atecub,reggub,dereggub,yreggub,ekakkub,tihs llub,parcllub,ekidllub,ekydllub,ebiv tellub,tihsllub,stihsllub,dettihsllub,sdrutllub,mub,yob mub,kcufelbmub,talcmub,kcufmub,remmub,gnub,eloh gnub,agnub,elohgnub,rekcuf ynnub,daol a tsub,ytsub,ekidhctub,ekydhctub,ttub,kcuf ttub,gulp ttub,gnabttub,gnab-ttub,skeehcttub,ecafttub,kcufttub,kcuf-ttub,akcufttub,rekcufttub,rekcuf-ttub,daehttub,elohttub,namttub,hcumttub,hcnumttub,rehcnumttub,etarip-ttub,gulpttub,k.c.0.c,.k.c.o.c,t.n.u.c,kc0c,k-c-0-c,rekcuskc0c,acac,enohac,eot lemac,eotlemac,lrigmac,tulsmac,erohwmac,rehcnum teprac,rehcnumteprac,kwac,xivrec,elcitsehc,nam ihc-ihc,kcid a htiw kcihc,rekcuf-dlihc,nihc,cnihc,scnihc,knihc,yknihc,daohc,edaohc,eci cohc,sdubesor etalocohc,edohc,sedohc,sgab atohc,apic,krejelcric,t1lc,remaets dnalevelc,xamilc,tilc,rekcil tilc,ecaftilc,kcuftilc,sirotilc,surotilc,stilc,yttilc,rettil yttilc,gowgolc,spmalc revolc,egnulc,kcufretsulc,tunc,niacoc,eniacoc,kcoc,k-c-o-c,tekcop kcoc,tons kcoc,rekcus kcoc,ssakcoc,etibkcoc,kcolbkcoc,regrubkcoc,eyekcoc,ecafkcoc,rekcufkcoc,daehkcoc,retslohkcoc,yekcojkcoc,rekconkkcoc,rekonkkcoc,rekcilkcoc,revolkcoc,pmulkcoc,retsamkcoc,relgnomkcoc,leurgnomkcoc,yeknomkcoc,hcnumkcoc,rehcnumkcoc,esonkcoc,teggunkcoc,skcoc,tihskcoc,htimskcoc,ekomskcoc,rekomskcoc,reffinskcoc,recuskcoc,kcuskcoc, kcuskcoc,dekcuskcoc,rekcuskcoc,rekcus-kcoc,srekcuskcoc,gnikcuskcoc,skcuskcoc,akuskcoc,akkuskcoc,elffawkcoc,regdod niffoc,latioc,koc,rehcnumkoc,akcuskoc,eimmoc,modnoc,eihcooc,yhcooc,nooc,ssannooc,snooc,retooc,doow emos poc,aingalorpoc,ailihporpoc,rekcuskroc,elohnroc,erohw proc,xoc,sbarc,kcarc,rekcarc,erohwkcarc,erohw-kcarc,parc,ypparc,eipmaerc,niterc,yekirc,elppirc,ettorc,muc,regguhc muc,retspmud muc,kaerf muc,relzzug muc,elbbubmuc,pmudmuc,retspmudmuc,relzzugmuc,yekcojmuc,remmuc,nimmuc,gnimmuc,smuc,tohsmuc,stohsmuc,tulsmuc,niatsmuc,tratmuc,sugnilinuc,sugnillinuc,nnuc,einnuc,sugnilinnuc,ttnnuc,ynnuc,tnuc,t-n-u-c,riah tnuc,ssatnuc,gabtnuc,ecaftnuc,kcuftnuc,rekcuftnuc,elohtnuc,retnuhtnuc,kciltnuc, kciltnuc,rekciltnuc, rekciltnuc,gnikciltnuc,gartnuc,stnuc,elcistnuc,tulstnuc,kcurts-tnuc,rekcustnuc,epor tuc,silayc,cufrebyc,kcufrebyc,dekcufrebyc,rekcufrebyc,srekcufrebyc,gnikcufrebyc,xesrebyc,gn0d,3hcu0d,ehcu0d,kc1d,0dl1d,odl1d,ogad,sogad,timmad,nmad,denmad,tinmad,eikrad,nrad,epar etad,eparetad,elyts-eigwad,taorht peed,taorhtpeed,ogged,ailihpordned,kcid,daeh kcid,eloh kcid,yhs kcid,gabkcid,sretaebkcid,niarbkcid,reppidkcid,ecafkcid,reppilfkcid,kcufkcid,rekcufkcid,daehkcid,sdaehkcid,elohkcid,hsikcid,hsi-kcid,eciujkcid,klimkcid,regnomkcid,reppirkcid,skcid,reppiskcid,palskcid,ezeens-kcid,rekcuskcid,gnikcuskcid,relkcitkcid,dawkcid,lesaewkcid,deewkcid,reppihwkcid,dowkcid,reppizkcid,elddid,ekid,odlid,sodlid,fagilid,deewllid,tiwmid,elgnid,seirrebelgnid,yrrebelgnid,knid,sknid,pihspid,tihspid,asrid,ytrid,swollip ytrid,zehcnas ytrid,kcld,elyts god,rekcuf-god,elyts eiggod,elytseiggod,elyts-eiggod,niggod,gniggod,elyts yggod,elytsyggod,elyts-yggod,tteclod,noitanimod,xirtanimod,semmod,gnod,hcnup yeknod,hcnupyeknod,rebbiryeknod,gabhcood,sufood,eikood,hsood,yepod,gnod elbuod,noitartenep elbuod,tfilelbuod,3hcuod,ehcuod,gabehcuod,sgabehcuod,gaf-ehcuod,elffawehcuod,yehcuod,noitca pd,knurd,pmuh yrd,ehcud,ssamud,ssa bmud,ssabmud,sessabmud,tnucbmud,kcufbmud,tihsbmud,ymmud,tihsmud,advd,ekyd,sekyd,kcid a tae,eip riah tae,ssa ym tae,yssuptae,ihcce,etalucaje,detalucaje,setalucaje,gnitalucaje,sgnitalucaje,noitalucaje,etalukaje,tnemegralne,tcere,noitcere,citore,msitore,trocse,eebhosse,hcunue,ycatxe,ysatxe,k c u f,r e k c u f,k.c.u.f,k_c_u_f,ynn4f,rekcufecaf,laicaf,kcaf,gaf,gabgaf,rekcufgaf,ggaf,deggaf,gniggaf,tiggaf,ttiggaf,toggaf,kcoctoggaf,stoggaf,sggaf,togaf,stogaf,sgaf,dratgaf,giaf,tgiaf,ynnaf,tidnabynnaf,spalfynnaf,rekcufynnaf,yynaf,traf,rekconktraf,kcuftsaf,taf,ssataf,kcuftaf,rekcuftaf,kucf,rekucf,gnikucf,lacef,kcef,rekcef,hclef,rehclef,gnihclef,etallef,oitallef,hctlef,rehctlef,gnitriuqs elamef,modmef,nainef,gniggif,gnabregnif,kcufregnif, kcufregnif,dekcufregnif,rekcufregnif, rekcufregnif,srekcufregnif,gnikcufregnif,skcufregnif,gniregnif,kcuf tsif,detsif,kcuftsif,dekcuftsif,rekcuftsif, rekcuftsif,srekcuftsif,gnikcuftsif,sgnikcuftsif,skcuftsif,gnitsif,ytsif,remalf,egnalf,spalf,etulfhself,gol eht golf,yzoolf,daof,haof,eldnof,raboof,koof,rekoof,hsitef toof,kcuftoof,rekcuftoof,bojtoof,rekciltoof,nikserof,kcufkaerf,rekcufykaerf,kcufeerf,xeerf,ggirf,aggirf,gnittorf,rabuf,cuf,kcuf,k-c-u-f,snottub kcuf,eloh kcuf,ffo kcuf,teppup kcuf,yhport kcuf,amam oy kcuf,uoy kcuf,akcuf,ssakcuf,ssa-kcuf,gabkcuf,hctib-kcuf,yobkcuf,niarbkcuf,ttubkcuf,rettubkcuf,dekcuf,pudekcuf,rekcuf,srekcuf,rekcusrekcuf,ecafkcuf,kaerfkcuf,daehkcuf,sdaehkcuf,rehkcuf,elohkcuf,nikcuf,gnikcuf,hctibgnikcuf,sgnikcuf,rekcufrehtomtihsgnikcuf,emkcuf, emkcuf,taemkcuf,drahemkcuf,yeknomkcuf,teggunkcuf,tunkcuf,ttunkcuf,ffokcuf,skcuf,kcitskcuf,dratkcuf,drat-kcuf,sdratkcuf,tratkcuf,yotkcuf,tawtkcuf,pukcuf,dawkcuf,tihwkcuf,erohwkcuf,tiwkcuf,ttiwkcuf,uoykcuf,rekcap egduf,rekcapegduf,rekcap-egduf,kuf,rekuf,rekkuf,srekkuf,nikkuf,skuf,tihwkuf,tiwkuf,quf,iranatuf,xuf,r0xuf,kcvf,kcxf,eag,iag,gnab gnag,gnabgnag,gnab-gnag,degnabgnag,sgnabgnag,ajnag,hsag,ssa yssag,xes yag,ssayag,bobyag,odyag,kcufyag,tsikcufyag,drolyag,syag,xesyag,dratyag,dawyag,redneb redneg,slatineg,yeg,yfg,yahg,yehg,kcoc tnaig,ologig,regnig,oppig,no lrig,pot no lrig,dliw enog slrig,tig,snalg,xctaog,estaog,nmad dog,nmadog,tinmadog,maddog,mad-dog,timmaddog,nmaddog,denmaddog,denmad-dog,tinmaddog,rekcufahtumnmaddog,nmadsdog,nukkog,rewohs nedlog,rewohsnedlog,gowillog,danog,sdanog,aeherronog,lrig oog,hcoog,poopdoog,koog,skoog,msagerog,llehotog,ognirg,eporg,xes puorg,topsg,tops-g,oftg,odiug,orug,0m0h,om0h,palf mah,boj dnah,bojdnah,eroc drah,no drah,erocdrah,xeserocdrah,11eh,kcufdaeh,ebeh,beeh,lleh,pmeh,iatneh,nioreh,preh,sepreh,ypreh,ehseh,ehs-eh,reltih,vih,oh,raoh,eraoh,gaboh,eoh,reoh,tihs yloh,0moh,yemoh,omoh,tihsbmudomoh,citoreomoh,yeomoh,yeknoh,yknoh,hcooh,hakooh,rekooh,rooh,hctooh,retooh,sretooh,eroh,tseinroh,ynroh,lrac toh,kcihc toh,yssuptoh,xestoh,llik ot woh,pedrum ot woh,redrum ot woh,taf eguh,pmuh,depmuh,gnipmuh,nuh,yssuh,nemyh,pai,pals nairebi,derbni,tsecni,nujni,esruocretni,ff0kr3j,ffo kcaj,ssakcaj,sessakcaj,elohkcaj,ffokcaj,ffo-kcaj,iggaj,ffogaj,tiab liaj,tiabliaj,paj,spaj,tunod yllej,krej,ffo krej,ff0krej,ssakrej,dekrej,ffokrej,ffo-krej,oobagij,oobaggij,oobreggij,msij,zij,mzij,zzij,dezzij,kcoj,sgguj,ynnub elgnuj,ynnubelgnuj,eiknuj,yknuj,rifak,kwak,ekik,sekik,llik,ukabnik,retsknik,yknik,kkk,nalk,bonk,dne bonk,gnibbonk,daebonk,debonk,dnebonk,daehbonk,ykcojbonk,yekojbonk,kcok,mudnok,smudnok,hcook,sehcook,hctook,tuark,muk,remmuk,gnimmuk,smuk,sugnilinuk,ajnuk,tnuk,fiwk,ekyk,hc+i3l,hcti3l,aibal,ssaemal,ssadral,tniartser rehtael,tekcaj thgiarts rehtael,hcel,ytrap nomel,repel,naibsel,snaibsel,obsel,sobsel,zel,naibzel,snaibzel,obzel,sobzel,azzel,eizzel,seizzel,yzzel,oaml,oafml,niol,sniol,atilol,yenool,gnikamevol,ebul,tsul,gnitsul,ytsul,0f0m,of0m,etabret54m,8bret5am,etabret5am,ylgufam,emoc em ekam,gnitriuqs elam,smam,tsihcosam,assam,8bretsam,tabretsam,3tabretsam,etabretsam,etab-retsam,gnitabretsam,noitabretsam,snoitabretsam,etabrutsam,gnitabrutsam,noitabrutsam,ixam,teggafcm,siort a eganem,sesnem,etaurtsnem,noitaurtsnem,htem,gnikcuf-m,kcim,regnif elddim,tegdim,flim,egnim,regnim,noitisop yranoissim,0fom,ofom,of-om,tselom,gnom,oof oof oom oom,eiloom,norom,kcufahtom,akcufahtom,sakcufahtom,zakcufahtom,dekcufahtom,rekcufahtom,srekcufahtom,nikcufahtom,gnikcufahtom,sgnikcufahtom,skcufahtom,rekcuf rehtom,kcufrehtom,akcufrehtom,dekcufrehtom,rekcufrehtom,srekcufrehtom,nikcufrehtom,gnikcufrehtom,sgnikcufrehtom,akkcufrehtom,skcufrehtom,sunev fo dnuom,sdnah rm,rekcufrehtm,rekcufrhtm,gnikcufrhtm,ffum,revid ffum,ffup ffum,revidffum,gnividffum,gnignum,retnum,redrum,ahtum,rekcefahtum,zakcufahtum,rekkcufahtum,rehtum,rekcufrehtum,gnikcufrehtum,gnikcufrhtum,agg1n,regg1n,dan,sdan,dekan,albman,mlapan,yppan,ihsawan,izan,msizan,kcid eht deen,orgen,izanoen,gon gin,oobagin,r3ggin,h4ggin,aggin,haggin,saggin,zaggin,reggin,sreggin,elggin,telgin,gon-gin,ainamohpmin,dormin,ynnin,elppin,selppin,bon,yekoj bon,daehbon,ykcojbon,yekojbon,ecnon,ykoon,segami wfsn,edun,ytidun,stunbmun,rettub tun,kcas tun,kcastun,rettun,ohpmyn,ainamohpmyn,yssupotco,gab dlo,gmo,ihsaromo,slrig owt puc eno,raj eno yug eno,etaipo,muipo,laro,yllaro,nagro,misagro,smisagro,msagro,cimsagro,smsagro,seigro,ygro,yravo,muvo,smuvo,.y.s.s.u.p,nr0p,yddap,elihpodeap,ikap,hcoonap,ysnap,eitnap,seitnap,ytnap,eitsap,ytsap,nwap,pcp,rekcep,daehrekcep,odep,raebodep,elihpodep,ailihpodep,cailihpodep,eep,eepeep,gniggep,etartenep,noitartenep,lainep,elinep,sinep,regnabsinep,rekcufsinep,reffupsinep,noisrevrep,etoyep,illahp,cillahp,xes enohp,xesenohp,kcuhp,kuhp,dekuhp,gnikuhp,dekkuhp,gnikkuhp,skuhp,quhp,tihs fo eceip,rekcufgip,yekip,retibwollip,pmip,sipmip,oknip,ssip,ffo ssip,gip ssip,dessip,ffo dessip,ressip,sressip,sessip,spalfssip,nissip,gnissip,ffossip,ffo-ssip,gipssip,yobyalp,tsehc erusaelp,smp,kcalop,rekoms elop,rekomselop,kcollop,yalpynop,foop,noop,inanoop,ynanoop,gnatnoop,poop,etuhc poop,etuhcpoop,rehcnupoop,yeknom hcrop,yeknomhcrop,nrop,onrop,yhpargonrop,sonrop,top,yttop,kcirp,skcirp,resaetkcirp,girp,gnicreip trebla ecnirp,dorp,norp,etutitsorp,edurp,ohcysp,chtp,ebup,sebup,cibup,sibup,inanup,ynnanup,ynanup,ssaknup,yknup,atnup,ssup,essup,issup,seissup,yssup,traf yssup,ecalap yssup,gnikcilyssup,rednuopyssup,syssup,tsup,otup,faeuq,feeuq,reeuq,tiabreeuq,elohreeuq,oreeuq,sreeuq,ykciuq,miuq,ycar,daehgar,renob gnigar,epar,depar,repar,yepar,gnipar,tsipar,hcnuar,latcer,mutcer,sutcer,refeer,drateer,hcier,boner,drater,dedrater,lrigwoc esrever,euver,wajmir,bojmir,gnimmir,dratir,mlap ysor,sretsis 5 reh dna mlap ysor,dratr,drat-r,hsibbur,mur,pmur,remmarpmur,iksur,enobmort ytsur,tih s,m&s,.t.i.h.s,.b.o.s,t_i_h_s,b0s,msidas,tsidas,obmas,reggin dnas,rabdnas,reldnas,reggindnas,regnas,murotnas,neeuq egasuas,gacs,ylitnacs,tacs,ozihcs,gnolhcs,gnirossics,wercs,dewercs,gniwercs,taorcs,gorcs,torcs,etorcs,mutorcs,durcs,mucs,namaes,nemaes,ecudes,skes,nemes,xes,oxes,lauxes,yxes,+!hs,t!hs,t1hs,t-1-h-s,gahs,reggahs,niggahs,gniggahs,emademahs,revaeb devahs,yssup devahs,elamehs,+ihs,irabihs,retfil trihs,tihs,t-i-h-s,ssa tihs,rekcuf tihs,ssatihs,gabtihs,reggabtihs,pmilbtihs,sniarbtihs,htaerbtihs,dennactihs,tnuctihs,kcidtihs,etihs,retaetihs,detihs,yetihs,ecaftihs,decaftihs,kcuftihs,lluftihs,daehtihs,sdaehtihs,elohtihs,esuohtihs,gnitihs,sgnitihs,stihs,rettipstihs,niatstihs,ttihs,dettihs,rettihs,srettihs,reittihs,tseittihs,gnittihs,sgnittihs,yttihs,zihs,tinzihs,atohs,gnipmirhs,yssis,gaks,knaks,teeks,kcuflluks,gals,eyetnals,evals,ezaels,yzaels,epols,tuls,tekcub tuls,gabtuls,repmudtuls,ssiktuls,stuls,ssatrams,sessatrams,gems,amgems,tums,yttums,hctans,repins,gnillabwons,ffuns,b-o-s,ffo dos,modos,ezimodos,ymodos,hctib a fo nos,taog sselrehtom a fo nos,erohw a fo nos,hctib-a-fo-nos,esuos,desuos,caps,edaps,mreps,cips,kcips,kips,skips,egoolps,esoom egoolps,egoops,koops,sgel daerps,knups,ymaets,ufts,yffits,denots,no parts,noparts,odapparts,pirts,bulc pirts,ekorts,diputs,yggod elyts,kcus,ssakcus,dekcus,gnikcus,skcus,slrig edicius,nemow yrtlus,hctaibafomus,akitsaws,regniws,t1t,5e1tt1t,seitt1t,ffat,giat,evol detniat,ssip eht gnikat,nopmat,drat,trat,ym etsat,yrdwat,gniggab aet,gniggabaet,taet,steet,zeet,dret,etset,eetset,setset,lacitset,elcitset,sitset,emoseerht,gnitaorht,tsurht,guht,tnucrednuht,pu deit,etihw thgit,elknit,tit,knaw tit,kcuftit,itit,seitit,stit,ttit,5eittit,rekcufeittit,seittit,yttit,kcufyttit,rekcufyttit,knawyttit,knawtit,ekot,a ni eugnot,stoot,sselpot,ressot,daehlewot,pmart,ynnart,lauxessnart,yhsart,msidabirt,depmurt,lrig but,lrigbut,drut,hsut,yhsut,t4wt,tawt,daehtawt,spiltawt,stawt,yttawt,elffawtawt,kniwt,eikniwt,sregnif owt,eugnot htiw sregnif owt,puc eno slrig owt,tnuwt,retnuwt,ylgu,rekcufelcnu,seidnu,gnisserdnu,dewnu,trikspu,yalp arhteru,laniru,eniru,ailihporu,suretu,izu,arg41v,arg1v,gav,anigav,yajyajav,j-j-av,muilav,dnuom sunev,elbatqev,argaiv,rotarbiv,dnaw teloiv,nigriv,nexiv,yajyajv,akdov,timov,ailihperarov,rueyov,ragluv,avluv,es00w,daw,gnaw,knaw,reknaw,bojknaw,yknaw,oozaw,eigdew,deew,eineew,eeweew,reniew,odriew,hcnew,maerd tew,kcabtew,er0hw,ecafer0hw,rewop etihw,yetihw,zihw,raohw,suoicilarohw,erohw,suoicilaerohw,gaberohw,derohw,ecaferohw,reppoherohw,esuoherohw,serohw,gnirohw,reggiw,seilliw,ylliw,rekcil wodniw,ssaesiw,sessaesiw,gow,bmow,ydoow,pow,nem gnipparw,hsifrats delknirw,ftw,detarx,detar-x,xx,xxx,ioay,ytsaey,srewohs wolley,diy,yffiy,obboy,elihpooz,ailihpooz,bbuz,eloha,suna,el0hsa,sel0hsa,selohsa,ssa,yeknoM ssA,ecafssA,el0hssa,zel0hssa,elohssa,selohssa,zlohssa,epiwssa,elohzza,sdretssab,dratsab,sdratsab,zdratsab,sdretsab,zdretsab,hctaiB,hctib,sehctib,boJ wolB,gniffob,elohttub,epiwttub,kc0c,skc0c,k0c,rehcnuM tepraC,kwac,skwac,tilC,stnc,ztnc,kcoc,daehkcoc,daeh-kcoc,skcoc,rekcuSkcoC,rekcus-kcoc,parc,muc,tnuc,stnuc,ztnuc,kcid,0dlid,s0dlid,odlid,sodlid,0dllid,s0dllid,skcirtanimod,scirtanimod,xirtanimod,ekyd,amene,k c u f,r e k c u f,gaf,t1gaf,tegaf,t1ggaf,tiggaf,toggaf,t0ggaf,tigaf,sgaf,zgaf,giaf,sgiaf,traf,drib eht gnippilf,kcuf,rekcuf,nikcuf,gnikcuf,skcuf,rekcaP egduF,kuf,hakuF,nekuF,rekuf,nikuF,kkuF,hakkuF,nekkuF,rekkuF,nikkuF,k00g,denmad-doG,r00h,ra0h,er0h,slleh,raoh,rooh,erooh,ffokcaj,paj,spaj,ffo-krej,misij,ssij,mzij,zzij,bonk,sbonk,zbonk,tnuk,stnuk,ztnuk,naizzeL,stihspiL,ztihspiL,tsihcosam,tsikosam,tiabretssam,tiabrtssam,etabrtssam,retiabretsam,etabretsam,setabretsam,rekcuF ahtoM,rekuF ahtoM,hakkuF ahtoM,rekkuF ahtoM,rekcuF rehtoM,hakuF rehtoM,rekuF rehtoM,hakkuF rehtoM,rekkuF rehtoM,rekcuf-rehtom,rekcuF ahtuM,hakuF ahtuM,rekuF ahtuM,hakkuF ahtuM,rekkuF ahtuM,rg1n,ttsan,;reggin,;rugin,;regiin,;rgiin,sifaro,;misagro,msagro,musagro,ecafiro,ecifiro,ssifiro,ikcap,eikcap,ykcap,ikap,eikap,ykap,rekcep,suneeep,sssuneeep,suneep,suniep,s1nep,sanep,sinep,htaerb-sinep,sunep,suunep,cuhP,kcuhP,kuhP,rekuhP,rekkuhP,calop,kcalop,kalop,inanooP,c1rp,kc1rp,k1rp,essup,eessup,yssup,ekuup,rekuup,riewq,mutkcer,mutcer,drater,tsidas,knacs,gnolhcs,gniwercs,nemes,xes,yxes,t!hS,t1hs,ret1hs,st1hs,rett1hs,zt1hs,tihs,stihs,rettihs,yttihS,ytihS,ztihs,tyhS,etyhS,yttyhS,ytyhS,kcnaks,knaks,eeknaks,yeknaks,sknaks,yknakS,gals,tuls,stuls,yttulS,ztuls,hctib-a-fo-nos,tit,drut,anij1av,an1gav,aniigav,anigav,an1jav,anijav,avlluv,avluv,p0w,r00hw,er0hw,erohw,detarx,xxx,hc+!b,hctib,bojwolb,tilc,hcolhcsra,kcuf,tihs,ssa,elohssa,hct!b,hc71b,hct1b,dratsab,hc+ib,saloiob,atecub,kc0c,kwac,knihc,apic,stilc,kcoc,muc,tnuc,odlid,asrid,etalukaje,ssataf,kucf,kuf,r0xuf,reoh,eroh,msij,kwak,hcti3l,hc+i3l,etabrutsam,*tabretsam,3tabretsam,rekcufrehtom,.b.o.s,ofom,izan,aggin,reggin,kcastun,kcuhp,sipmip,essup,yssup,mutorcs,t!hs,elamehs,+ihs,+!hs,tuls,tums,steet,stit,sboob,sb00b,zeet,lacitset,elcitset,ttit,es00w,ffokcaj,knaw,raohw,erohw,nmad*,ekyd*,*kcuf*,*tihs*,kicma,atoksdna,*esra,remmarssa,riya,hc7ib,*hctib,*kcollob,stsaerb,etarip-ttub,norbac,ozzac,aarhc,juhc,*kcoC,*tnuc,nm4d,ogyad,oged,*kcid,*ekid,apud,akwizd,etalukcaje,*merkE,otkE,relucne,neaf,*gaf,olucnaf,ynnaf,secef,gef,rehcleF,nekcif,ttif,rekkilF,nikserof,eztoF,*(uF,*kuf,nzterktuf,koog,aneiug,r0h,r0x4h,lleh,etevleh,*reoh,yeknoh,noveuH,iuh,nujni,zzij,*reknak,ekik,kaztoolk,tuark,ellunk,kuk,reguskuk,caruK,awruk,*isuk,*apryk,obsel,noohmam,*tabrutsam,*drem,nubim,hgielknom,poweiluom,eium,ukklum,ihcsum,sizan,oiruasepen,*reggin,upsoro,*aksap,esrep,akcip,*lodreip,*ullip,lemmip,*ssip,adzip,eestnoop,poop,nrop,nr0p,n0rp,neeterp,alup,elup,atup,otup,hebhaq,*feeuq,grebnetuar,reffahcs,*ssiehcs,epmalhcs,kcumhcs,wercs,*t!hs,atumrahs,etumrahs,lapihs,zihs,zbirks,nysywruks,retcnehps,cips,jaladreips,egoolps,akus,*b00b,*elcitset,*ttit,tawt,uttiv,*knaw,*kcabtew,reshciw,*pow,dey,haruobaz,revoldeew,eiknujeniacoc,96,ynroh,bmob xes,ologig,anigav,yssup,kcid,elohssa,ttub,daehkcid,tilc,bojwolb,elytsyggod,toggaf,rekcuf,erohw,tuls,reredrum,tsirorret,susej,halla,nasamam,etutitsorp,aggin,relliK,ooP,yaG,naibsel,ahddub,SISI,iabiC,oaijnaL,diputS,toidI,obmiB,seiboob,ratsnrop,lrigmac,nafylno,reknaw,elihpodeP,revoldeew,eiknujeniacoc,96,ynroh,bmob xes,ologig,anigav,yssup,kcid,elohssa,ttub,daehkcid,tilc,bojwolb,elytsyggod,toggaf,rekcuf,erohw,tuls,reredrum,tsirorret,susej,halla,nasamam,etutitsorp,aggin"
        const profanityWords = profList.split(',').map(word => word.split('').reverse().join('').replace(/[.+*^$|(){}\]\\]/g, '\\$&'))
        const pattern = profanityWords.join('|');
        const profanityRegex = new RegExp(`\\b(${pattern})\\b`, 'gi');
        const isProfanity = profanityRegex.test(input);
        let censored = '';
        // if (isProfanity) {
        //     censored = input.replace(profanityRegex, match => '*'.repeat(match.length));
        // }
        return {isProfanity: isProfanity, censored: censored}
    },
    isEmptyObject(data){
        return _.isEmpty(data);
    },
    validateNullEquivalent(input) {
        // Convert anything to string
        const value = String(input).trim().toLowerCase();
        //console.log("validateNullEquivalent, value to check: "+value)
        const nullEquivalents = [
            "n/a",
            "na",
            "n.a.",
            "n.a",
            "nil",
            "none",
            "no value",
            "blank",
            "empty",
            "--",
            "-",
            "0",
            "not provided",
            "not entered",
            "not applicable",
            "unavailable",
            "unknown",
            "null"
        ];

        const isNullEquivalents = nullEquivalents.includes(value);
        //console.log("isNullEquivalents "+value+"? "+isNullEquivalents)
        return !isNullEquivalents;
    }
}

// Change value according to rules.
const enforce = {
    numberOnly(inputString){
        return _.isNaN(parseInt(inputString)) ? "" : parseInt(inputString) ;
    },
    maxLength(inputString, maxNumber){
        let result = inputString
        if ( inputString.length > maxNumber ) {
          result = inputString.substring(0, maxNumber)
        }
        return result
    },
    maxAmount(inputAmount, maxAmount){
        let result = inputAmount
        if ( parseFloat(inputAmount) > maxAmount ) {
            result = maxAmount
        }
        return result
    },
    validDecimal(inputString){
        let result = inputString
        let inputSplit = inputString.split(".")
        if ( inputSplit.length > 2 ) {
            result = inputSplit.slice(0, 2).join(".")
        }
        return result
    }
}

const templateEl = {
    smartSelectDismiss(text){
        return '<div class="smart-select-footer wandr-paragraph-1">'+
                    '<a class="link sheet-close button button-large button-fill button-round color-primary">'+text+'</a>'+
                '</div>';
    }
}

const beneHelper = {
    sortServiceTypeList(serviceTypeList) {
        const stList = serviceTypeList;
        const stText = [];

        for(let i=0; i < stList.length; i++) {
          stText[i] = stList[i].value.toUpperCase() + "," +
            stList[i].value + "," +
            stList[i].key;
        }

        stText.sort();

        for(let i=0; i < stList.length; i++) {
          let parts = stText[i].split(',');

          stList[i].value = parts[1];
          stList[i].key = parts[2];
        }
    }
}

const dateHelper = {
    // DR-1931: MyInfo's idExpiryDate (Pass expiry date) arrives as a full ISO datetime
    // (a Date value serialized with a 00:00:00 time-of-day component), same as dateOfBirth.
    // The verify-detail screen only ever displays the date portion, so strip the time here
    // the same way the existing DOB formatting in register-enter-details.vue etc. does.
    formatDateOnly(rawDate){
        if (!rawDate) { return ''; }
        const dateVal = new Date(rawDate);
        if (!(dateVal instanceof Date) || isNaN(dateVal)) { return ''; }

        const yyyy = dateVal.getFullYear();
        let mm = dateVal.getMonth() + 1; // Months start at 0!
        let dd = dateVal.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        return dd + '-' + mm + '-' + yyyy;
    }
}

const fxRateHelper = {
    buildRateList(fxRateList){
        let fromBaseList = {}, toBaseList = {};

        _.each(fxRateList, (fxRate) => {
            let param = fxRate.deliveryMethodId + "-" + fxRate.currencyId + "-" + fxRate.bankTypeId;
            fromBaseList[fxRate.baseCurrencyId] = fromBaseList[fxRate.baseCurrencyId] || {};
            if (! fromBaseList[fxRate.baseCurrencyId][param]) {
                fromBaseList[fxRate.baseCurrencyId][param] = fxRate;
            }
        })
        _.each(fxRateList, (fxRate) => {
            let param = fxRate.deliveryMethodId + "-" + fxRate.baseCurrencyId + "-" + fxRate.bankTypeId;
            toBaseList[fxRate.currencyId] = toBaseList[fxRate.currencyId] || {};
            if (! toBaseList[fxRate.currencyId][param]) {
                toBaseList[fxRate.currencyId][param] = fxRate;
            }
        })

        return {
            fromBaseList: fromBaseList,
            toBaseList: toBaseList,
        }
    },
    getFxRateFromList(list, host, home){
        let fromCurrId, toCurrId, newList, tmpId, tmp;
        if (_.isEmpty(list)) {
            return void 0;
        } else {
            fromCurrId  = host.countryId ;
            toCurrId    = home.dmId + "-" + home.countryId + (home.dmId != 2 ? "-" + home.bankTypeId : "")

            newList = list.fromBaseList[fromCurrId] ? list.fromBaseList[fromCurrId][toCurrId] : null;
            if (! newList) {
                newList = list.toBaseList[fromCurrId] ? _.clone(list.toBaseList[fromCurrId][toCurrId]) : null;
            if (!newList) return {};
                tmpId                          = newList.baseCurrencyId;
                tmp                            = newList.baseCurrency;
                newList.baseCurrencyIdOriginal = newList.baseCurrencyId;
                newList.conversion             = newList.baseCurrency + ' / ' + newList.currency;
                newList.baseCurrencyId         = newList.currencyId;
                newList.baseCurrency           = newList.currency;
                newList.currencyId             = tmpId;
                newList.currency               = tmp;
                newList.bidRateOriginal        = newList.bidRate;
                newList.bidRate                = 1 / newList.bidRate; // probably need numeral js
                newList.isReverse              = true;

            } else {
                newList.conversion = newList.baseCurrency + ' / ' + newList.currency;
            }

            return newList;
        }
    },
    rearrageCountryList(fxCountryList, fxRateList){

        let fxCountryArrangement = [238, 95, 152, 208, 13, 99, 167, 128, 197, 221, 228, 236, 98, 18, 44, 106, 111, 145, 205, 253]
        ,   fxCountryCurrencyConfig = {
                "238" : {alias : 'European Euro'},
                "95"  : {alias : 'Hong Kong Dollar'},
                "152" : {alias : 'New Zealand Dollar'},
                "208" : {alias : 'Thai Baht'},
                "13"  : {alias : 'Australian Dollar'},
                "99"  : {alias : 'Indonesian Rupiah'},
                "167" : {alias : 'Philippines Peso'},
                "128" : {alias : 'Malaysian Ringgit'},
                "197" : {alias : 'Sri Lankan Rupee'},
                "221" : {alias : 'British Pound'},
                "228" : {alias : 'Vietnamese Dong'},
                "236" : {alias : 'Vietnam USD'},
                "98"  : {alias : 'Indian Rupee'},
                "18"  : {alias : 'Bangladeshi Taka'},
                "44"  : {alias : 'Chinese Yuan'},
                "106" : {alias : 'Japanese Yen'},
                "111" : {alias : 'South Korean Won'},
                "145" : {alias : 'Myanmar Kyat'},
                "205" : {alias : 'Taiwan dollar'},
                "253" : {alias : 'United States Dollar'},
            }
        ,   fxRateCountryList = []

        _.each(fxCountryArrangement, function(countryId) {

            for( let i = 0;  i < fxCountryList.length ; i++ ){
                if(countryId == fxCountryList[i].id){
                    fxCountryList[i].currencyAlias = fxCountryCurrencyConfig[countryId].alias

                    for ( let j = 0; j < fxRateList.length; j++ ) {
                        let thisRate = fxRateList[j]
                        if ( countryId == thisRate.baseCurrencyId ) {
                            fxCountryList[i].currencyCode = thisRate.baseCurrency;
                            break;
                        } else if ( countryId == thisRate.currencyId ) {
                            fxCountryList[i].currencyCode = thisRate.currency;
                            break;
                        }
                    }
                    fxRateCountryList.push(fxCountryList[i])
                    break;
                }
            }
        })

        /* WA-396 : sort alphabetically */
        fxRateCountryList.sort(function(a, b){
            if(a.currencyCode < b.currencyCode) { return -1; }
            if(a.currencyCode > b.currencyCode) { return 1; }
            return 0;
        })
        /* END OF WA-396 */
        
        return fxRateCountryList;
    },
    formatCurrency(num, conf){
        let decimalPoint = 2
        let confDefaults = { countryId: 0, isDisplay: false }
        if ( conf === undefined ) { conf = confDefaults }
        if ( conf.countryId ) {
            let noDecimalCountries = [99, 228]; // Indonesia, Vietnam

            let _isNoDecimal = !!~noDecimalCountries.indexOf(parseInt(conf.countryId));

            decimalPoint = _isNoDecimal ? 0 : 2 ;
        }


        let val = Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100
        let valFormatted = decimalPoint == 0 ? Math.floor(val) : (val).toFixed(decimalPoint)
        if (isNaN(valFormatted)){ valFormatted = 0 }
        if ( conf.isDisplay ) { valFormatted = valFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }

        return valFormatted
    },
    formatDisplayRate(num, conf){
        let decimalPoint = 4
        let confDefaults = { countryId: 0, isDisplay: false }
        if ( conf === undefined ) { conf = confDefaults }
        if ( conf.countryId ) {
            let noDecimalCountries = [99, 228]; // Indonesia, Vietnam
            let _isNoDecimal = !!~noDecimalCountries.indexOf(parseInt(conf.countryId));

            decimalPoint = _isNoDecimal ? 0 : 4 ;
        }

        let val = Math.round((parseFloat(num) + Number.EPSILON) * 10000) / 10000
        let valFormatted = decimalPoint == 0 ? Math.floor(val) : (val).toFixed(decimalPoint)
        let valFormattedString = ""
        if (isNaN(valFormatted)){ valFormatted = 0 }
        if ( conf.isDisplay ) {
            let amount = valFormatted.toString().split(".")
            valFormattedString = amount[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

            if(amount.length > 1){
                if(parseInt(amount[1].toString().slice(-1)) > 0){
                    valFormattedString = valFormattedString + "." + amount[1].toString()
                }else{
                    valFormattedString = valFormattedString + "." +  (( parseInt(amount[1].toString().slice(-2,-1)) > 0 ) ?  amount[1].toString().slice(0,3) :  amount[1].toString().slice(0,2) );
                }
            }
        }

        return valFormattedString
    }
}

export { check, enforce, templateEl, beneHelper, fxRateHelper, dateHelper }